import { z } from 'zod';
import { articlesProjectConfigSchema } from '../schemas/articlesProjectConfig';


export type ArticlesProjectConfig = z.infer<typeof articlesProjectConfigSchema>;

export async function useArticlesProjectConfig(): Promise<ArticlesProjectConfig> {
  const config = useRuntimeConfig();
  const result = await articlesProjectConfigSchema.safeParseAsync(config.public.articles);
  if (!result.success) {
    const msg = 'Invalid article project config';
    console.error(msg);
    throw new Error(msg);
  }
  return result.data
}
